module.exports = __webpack_public_path__ + "img/Clients.b3de622d.svg";